export const getters = {
  getContacts($state) {
    return $state.sortOrder.map(contactId => $state.records[contactId]);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContact: $state => id => {
    const contact = $state.records[id];
    return contact || {};
  },
  getMeta: $state => {
    return $state.meta;
  },
  getYclientsPhone: $state => {
    return $state.yclientsPhone;
  },
  getYclientsSalonId: $state => {
    return $state.yclientsSalonId;
  },
  getYclientsHash: $state => {
    return $state.yclientsHash;
  },
  getApplicationId: $state => {
    return $state.applicationId;
  }
};
